import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import Navigation from "../components/layout/Navigation";
import PageTransition from "../components/layout/PageTransition";
import SEO from "../components/helper/SEO";
import {graphql, StaticQuery} from "gatsby";
import MyPortableText from "../components/helper/MyPortableText";
import "../styles/global.scss";

const Layout = ({children, location, data}) => {

    const staticSettings = data?.allSanitySettings?.edges[0]?.node;
    const staticPages = data?.allSanityPage?.edges;
    const staticMetadata = data?.site?.siteMetadata;
    const [maintenancePage, setMaintenancePage] = useState(true);

    useEffect(() => {
        if (!location.hostname !== 'spleen-graz.at'){
            setMaintenancePage(false);
        }
    }, [location]);

    if (staticSettings?.maintenance?.maintenance && maintenancePage) {
        return (<>
            <SEO title={staticSettings?.maintenance_seo_title} description={staticSettings?.maintenance_seo_description} location={location}></SEO>
            <div className={"maintenance top-0 left-0 h-screen w-screen bg-white flex justify-center items-center flex-col px-10"} style={{
                height: '100vh',
                width: '100vw'
            }}>
                <div className="reveal mx-page">
                    <h1 className={`font-serif italic font-bold text-4xl medium:text-5xl tablet:text-7xl z-10 relative mb-5 center-aligned reveal`}>{staticSettings?.maintenancetitle}</h1>
                </div>
                <div className={"text-center mx-page max-w-[10px] reveal"}>
                    <MyPortableText value={staticSettings?._rawMaintenancetext}></MyPortableText>
                </div>
                <div className={"flex justify-center reveal mt-5 mx-page"}>
                    <a href={staticSettings?.maintenancebutton?.link} className={`nav-link h-7 block font-bold text-black dark:text-white border-2 border-black dark:border-white rounded-full px-3 transition-all ease-in-out duration-500 hover:bg-black hover:text-white`}>{staticSettings?.maintenancebutton?.title}</a>
                </div>
            </div>
        </>)
    } else{
        return (
            <div>
                <link rel="stylesheet" href="https://use.typekit.net/adr1eqm.css"></link>
                <Navigation metadata={staticMetadata} settings={staticSettings} location={location} pages={staticPages}></Navigation>
                <PageTransition location={location}>
                    {children}
                </PageTransition>
            </div>
        )
    }
}

// 👇 Query component
export default function myLayout(props) {
    return (<StaticQuery
        query={graphql`
        query SiteTitleQuery {
        site {
            siteMetadata {
                lang{
                _type
                en
                de
            }
            }
            }
          allSanitySettings{
                edges {
                    node {
                    navigation {
          links {
            link
            title {
              en
              _type
              de
            }
            color {
              hex
            }
          }
        }
        footer {
            link
            title {
              en
              _type
              de
            }
        }
                        maintenance{
                         maintenance_seo_description
                        maintenance_seo_title
                        maintenancetitle
                        maintenancebutton {
                            title{
                            en
                            de
                            _type
                            }
                            link{
                            en
                            de
                            _type
                            }
                        }
                        _rawMaintenancetext
                        }
                      
                        address_street
                        address_nr
                        address_plz
                        address_ort
                        sociallinks{
                            value
                            title
                            type
                        }
                        email
                        programmPassword
                    }
                }
            }
            allSanityPage {
            edges {
                node {
                    visibleFooter
                    title{
                        en
                        de
                        _type
                    }
                    slug{
                        current
                    }
                }
            }
        }
        }
      `}
        render={data => <Layout data={data} {...props} />}
    />);
}
